import { Logger, LogMessage } from 'pubnub';
import { createSafeProps } from 'src/lib/tcs-app-insights/app-insights-util';
import { AppInsightsLogger } from '../../tcs-logging/app-insights-logger';
import { LoggerOptionsService } from '../../tcs-logging/logger-options.service';
import { parsePubnubLog } from '../pubnub-config';

export class PubnubInsightsLogger implements Logger {
  constructor(private _logger: AppInsightsLogger, private _loggerSettings: LoggerOptionsService) {}

  public error(log: LogMessage): void {
    if (this._loggerSettings.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.error(`PubnubInsightsLogger Error: ${message}`, safeLog);
    }
  }

  public warn(log: LogMessage): void {
    if (this._loggerSettings.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.warning(`PubnubInsightsLogger Warning: ${message}`, safeLog);
    }
  }

  public info(log: LogMessage): void {
    if (this._loggerSettings.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.info(`PubnubInsightsLogger Info: ${message}`, safeLog);
    }
  }

  public debug(log: LogMessage): void {
    if (this._loggerSettings.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.info(`PubnubInsightsLogger Debug: ${message}`, safeLog);
    }
  }

  public trace(log: LogMessage): void {
    if (this._loggerSettings.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.info(`PubnubInsightsLogger Trace: ${message}`, safeLog);
    }
  }
}
